export const DashboardStatCards = ({ cards }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-8" data-testid="dashboard-stat-cards">
    {cards.map(({ key, label, value, icon: Icon }) => (
      <div key={key} className="border border-soft-gray rounded-2xl p-5" data-testid={`dashboard-stat-${key}`}>
        <Icon className="w-5 h-5 text-stranger-orange mb-3" />
        <p className="text-2xl font-extrabold">{value}</p>
        <p className="text-[11px] font-bold uppercase tracking-wide text-midnight-black/60 mt-1">{label}</p>
      </div>
    ))}
  </div>
);
